var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { show: _vm.animation_status === 1 }, attrs: { id: "boxmodel" } },
    [
      _c("div", { staticClass: "boxmodel_main" }, [
        _c("div", {
          staticClass: "boxmodel_layer",
          on: {
            mousedown: _vm.mousedown,
            mousemove: _vm.mousemove,
            mouseup: _vm.mouseup,
            mouseout: _vm.mouseout,
          },
        }),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "modelCanvas", attrs: { id: "modelCanvas" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }